export { clientCommunityDocumentService, CommunityDocumentService } from './community-document.service'

// 순서가 중요함
export const DocumentCategoryKeys = [
  'ask_doctor',
  'hospital_question',
  'plastic_surgery_question',
  'best', // 실제 카테고리 아님
  'doctor', // 실제 카테고리 아님
  'free_talk',
  'reviews',
  'medical_tip', // 실제 카테고리 아님
  'region',
]

export type DocumentCategoryKeyType = (typeof DocumentCategoryKeys)[number]

export const documentCategoryIdToKeyMap = new Map([
  [11, 'hospital_question'],
  [2, 'plastic_surgery_question'],
  [1, 'free_talk'],
  [5, 'reviews'],
  [13, 'ask_doctor'],
])

const documentCategoryKeyToIdMap = new Map()
documentCategoryIdToKeyMap.forEach((value, key) => {
  documentCategoryKeyToIdMap.set(value, key)
})

export enum DocumentCategoryId {
  HOSPITAL_QUESTION = 11,
  PLASTIC_SURGERY_QUESTION = 2,
  FREE_TALK = 1,
  REVIEWS = 5,
  ASK_DOCTOR = 13,
}

export { documentCategoryKeyToIdMap }
